import type { Layout } from "../tokens.ts";

/** C5 has no tagline token or meta field, so the tagline is part of the template text. */
export const PROPOSAL_TAGLINE = "Zorgeloos ondernemen begint bij heldere IT";

/** Derived from the BLS "IT voorstelling" proposal. */
export const proposalLayout: Layout = {
  key: "proposal",
  name: "Proposal",
  cover: [
    '<img class="kl-cover-logo" src="{{logo.cover}}" alt="">',
    '<p class="kl-cover-title">{{subtitle}}</p>',
    '<p class="kl-cover-tagline">{{docType}}</p>',
    '<p class="kl-cover-band">{{#client}}Opgesteld voor: {{client}}   |   {{/client}}Datum: {{date}}</p>',
  ].join("\n"),
  header: `<table class="kl-hf kl-hf-header"><tr><td class="kl-hf-left"><img class="kl-header-logo" src="{{logo.header}}" alt=""></td><td class="kl-hf-right kl-tagline">${PROPOSAL_TAGLINE}</td></tr></table>`,
  footer:
    '<table class="kl-hf kl-hf-footer"><tr><td class="kl-hf-left"></td><td class="kl-hf-right"><span class="kl-page-number"></span></td></tr></table>',
  css: `@page { margin-top: 128pt; @top-center { padding-top: 50pt; } }
@page kl-cover { margin-top: 128pt; @top-center { content: element(kl-header); } }
.kl-hf-header { border-bottom-width: 0.75pt; border-bottom-color: var(--kl-accent); }
.kl-hf-header td { vertical-align: top; padding-bottom: 20pt; }
.kl-header-logo { width: 66pt; height: 46.7pt; }
.kl-tagline { font-size: 8pt; font-style: italic; color: var(--kl-primary); }
.kl-hf-footer { border-top-width: 0; }
.kl-cover { padding-top: 70pt; text-align: center; }
.kl-cover-logo { display: block; width: 150pt; height: 106.1pt; margin: 0 auto; }
.kl-cover .kl-cover-title { margin-top: 70pt; font-size: 22pt; font-weight: bold; color: var(--kl-text); }
.kl-cover .kl-cover-tagline { margin-top: 4pt; padding-bottom: 9pt; border-bottom-style: solid; border-bottom-width: 0.75pt; border-bottom-color: var(--kl-accent); font-size: 12pt; font-style: italic; color: var(--kl-primary); }
.kl-cover .kl-cover-band { padding: 9pt 0; border-bottom-style: solid; border-bottom-width: 0.75pt; border-bottom-color: var(--kl-accent); color: var(--kl-text); }
.kl-body .kl-h1 { font-size: 15pt; color: var(--kl-text); border-bottom-width: 0.75pt; border-bottom-color: var(--kl-accent); }
.kl-body .kl-h1[data-number]::before { content: counter(kl-h1) ". "; color: var(--kl-text); }
.kl-body .kl-h2 { font-size: 12pt; }
`,
};
